import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Overline, FadeUp } from "./Motion";

export const FAQS = [
  {
    q: "What types of flooring does Fascinated by Floors supply?",
    a: "We supply the full flooring range: wooden flooring, laminate wooden flooring, engineered wood flooring, solid wood (hardwood) flooring, bamboo flooring, deck flooring and ipe wood decking, vinyl flooring, luxury vinyl tile (LVT), SPC flooring, sports flooring, and carpets — including carpet tiles and wall-to-wall broadloom carpets — all sourced from the world's leading manufacturers.",
  },
  {
    q: "Where can I buy the best wooden and laminate flooring for my project?",
    a: "Fascinated by Floors is a premium supplier of wooden and laminate flooring for residential, hospitality and commercial spaces. We help homeowners, architects and builders choose the right laminate wooden flooring, engineered wood or solid hardwood, and deliver samples, specifications and pricing on request.",
  },
  {
    q: "What is the difference between laminate, engineered wood and solid wood flooring?",
    a: "Laminate wooden flooring is a durable, cost-effective floor with a photographic wood layer — ideal for everyday spaces. Engineered wood flooring has a real hardwood top layer on a stable plywood core, perfect for large areas and under-floor heating. Solid wood flooring is a single piece of hardwood that can be sanded and refinished for decades. We stock all three so you can match the right floor to each project.",
  },
  {
    q: "Which flooring is best for high-traffic commercial, retail and hospitality spaces?",
    a: "For high-traffic commercial, retail, healthcare and hospitality projects we recommend vinyl flooring, luxury vinyl tile (LVT), SPC flooring, high-pressure flooring and contract carpet tiles — engineered for heavy footfall, easy maintenance and long life while still looking premium.",
  },
  {
    q: "Do you supply sports flooring for basketball courts, gyms and indoor stadiums?",
    a: "Yes. We supply performance-grade indoor sports flooring for basketball courts, multipurpose halls, gyms and indoor stadiums — including maple hardwood sports floors and cushioned vinyl sports surfaces that meet international play and safety standards.",
  },
  {
    q: "Is vinyl flooring, LVT and SPC flooring waterproof and suitable for wet areas?",
    a: "Vinyl flooring, luxury vinyl tile (LVT) and SPC (stone plastic composite) flooring are water-resistant to waterproof, warm underfoot and highly durable — making them a great choice for kitchens, bathrooms, offices and commercial interiors.",
  },
  {
    q: "What is a terracotta facade and where is it used?",
    a: "A terracotta facade is an exterior cladding system made of fired-clay panels or baguette louvres fixed to a building as a ventilated rainscreen. Terracotta facade cladding gives architecture a warm, timeless, breathable skin and is widely used on commercial buildings, institutions and premium residences. Terracotta facades are our signature product.",
  },
  {
    q: "Do you provide acoustic ceilings and metal waffle / grid ceilings?",
    a: "Yes. Our ceiling range covers acoustic grid ceilings, metal waffle ceilings and architectural ceiling systems that manage sound, light and geometry for offices, auditoriums, hotels and commercial interiors.",
  },
  {
    q: "Which global flooring and ceiling brands do you carry?",
    a: "We hand-pick and partner with leading global manufacturers including BerryAlloc, Forbo, Armstrong, Japan Carpet Co., Ntgrate, Kährs, Haro, Haima, Allflor, Egger, Krono Swiss and Rockwool International, bringing globally benchmarked surfaces to your project.",
  },
  {
    q: "Do you work with architects and builders — and how do I get a quote?",
    a: "Absolutely. We work closely with architects, interior designers and builders, providing specification-ready technical dossiers, samples and pricing. Simply use the Request a Quote form on this page and our specification team will get back to you, usually within one working day.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="bg-white py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Overline>Answers</Overline>
          <FadeUp>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-royal-deep leading-none">
              Frequently asked <span className="italic text-royal">questions.</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.1}>
            <p className="mt-6 text-muted-foreground lg:text-lg max-w-sm">
              Everything architects, builders and homeowners ask about flooring, ceilings and
              terracotta facades — answered.
            </p>
          </FadeUp>
        </div>

        <div className="lg:col-span-8">
          <FadeUp>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-black/10" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-display text-lg lg:text-xl text-royal-deep hover:no-underline py-6 [&>svg]:text-royal">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-muted-foreground leading-relaxed max-w-3xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
